<div class="page-not-found">
    <div class="not-found-card">
        <div class="badge-404">
            <span class="code">404</span>
            <span class="divider">•</span>
            <span class="text">Page Not Found</span>
        </div>

        <div class="media-wrapper">
            <div class="illustration-container">
                <img
                    class="illustration-img"
                    ngSrc="images/page-not-found.svg"
                    alt="404 Page Not Found"
                    width="360"
                    height="240"
                    priority
                />
            </div>
        </div>

        <div class="content-section">
            <h1 class="title">{{ 'sorryWeCouldntFindIt' | translate }}</h1>
            <p class="subtitle">
                The URL you requested could not be found or may have moved. Please check the address or return home.
            </p>
        </div>

        <div class="actions-group">
            <pims-button [label]="'backToHomePage'" [type]="'primary'" (afterClick)="redirectToHome()" />
            <pims-button
                [label]="'back'"
                [type]="'outlined'"
                [isIcon]="true"
                iconPath="images/chevron-left.svg"
                (afterClick)="goBack()"
            />
        </div>
    </div>
</div>
